// import { Link } from 'react-router-dom';

// material-ui
// import { useTheme } from '@mui/material/styles';
import { Box, Grid, Stack, Typography } from '@mui/material';

// project imports
// import AuthWrapper1 from '../AuthWrapper1';
// import AuthCardWrapper from '../AuthCardWrapper';
// import Logo from 'ui-component/Logo';
// import AuthRegister from '../auth-forms/AuthRegister';
// import AuthFooter from 'ui-component/cards/AuthFooter';
// import logo from '../../../../assets/images/logos/Group 1000002184.svg'
import { useEffect } from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';
import image1 from '../../../../assets/images/auth/SigninLeft/background (1).png'
import image2 from '../../../../assets/images/auth/SigninLeft/background.png'
import image3 from '../../../../assets/images/auth/SigninLeft/Illustration.png'
import { useState } from 'react';
import "./NewSignin.css"
// import UserRoles from 'views/utilities/UserRoles';
import ChangePasswordForm from '../auth-forms/ChangePasswordForm';
// assets

// ===============================|| AUTH3 - REGISTER ||=============================== //

const ChangePassword = () => {
    //   const theme = useTheme();
    //   const matchDownSM = useMediaQuery(theme.breakpoints.down('md'));

    // const navigate = useNavigate();
    // const location = useLocation();

    const [SelectedIndex, setSelectedIndex] = useState(0);

   


    useEffect(() => {
        const timer = setTimeout(() => {
            setSelectedIndex(prevState => (prevState === 2 ? 0 : prevState + 1));
        }, 3000);

        return () => clearTimeout(timer);
    }, [SelectedIndex]);



    // useEffect(() => {
    //     const token = sessionStorage.getItem('token');
    //     sessionStorage.clear()
    //     localStorage.clear()
    //     const handlePopState = (event) => {
    //         if (token) {
    //             // Prevent navigating back if token is present
    //             event.preventDefault();
    //             navigate('/'); // Replace with the desired route
    //         }
    //     };

    //     window.addEventListener('popstate', handlePopState);

    //     return () => {
    //         window.removeEventListener('popstate', handlePopState);
    //     };
    // }, [navigate, location]);




    return (
        <Grid container>
            <Grid item md={6} sm={0} xs={0} sx={{ display: { xs: 'none', sm: 'none', md: 'block' } }}>
                <Box sx={{

                    height: '100vh',
                    backgroundColor: "#592375",
                    padding: 2,
                }}>
                    <Stack justifyContent="space-between" alignItems="center" sx={{ height: "100%" }}>
                        <Box sx={{ display: "flex", alignItems: 'center', justifyContent: 'flex-start', height: "10%", width: '100%' }}>
                            <Typography variant='h5' textAlign="left" color="#fff" sx={{ fontSize: "27.72px", fontWeight: 700 }}>Network Manager</Typography>
                        </Box>
                        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "80%", position: "relative", width: "100%" }}>
                            <img src={image1} alt="img1"
                                style={{ position: "absolute", zIndex: 2, width: '65%' }} />

                            <img src={image2} alt="img2"
                                style={{ position: "absolute", zIndex: 1, width: '45%' }} />

                            <img src={image3} alt="img3"
                                style={{ position: "absolute", zIndex: 3, width: "45%", animation: "float 3s ease-in-out infinite 1s" }} />
                        </Box>

                   


                        <Box sx={{ display: "flex", flexDirection: 'column', alignItems: 'center', justifyContent: 'center', mb: 2 }}>
                            {
                                SelectedIndex === 0 ?
                                <Box sx={{ display: "flex",flexDirection:"column", justifyContent: "center", alignItems: "center", width: "100%", height: "100%"}}>
                                    <Typography className='FontInter' variant='h5' color="#fff" sx={{ fontSize: "22px", fontWeight: 700, fontFamily: 'sans-serif' }}>Network Manager</Typography>
                                    <Typography className='FontInter' variant='body' color="#fff" sx={{ fontSize: "14px", fontWeight: 300, mt: 1 }}>Everything you need in an easily customizable dashboard.</Typography>
                                </Box>
                                :
                                SelectedIndex === 1 ?
                                <Box sx={{ display: "flex",flexDirection:"column", justifyContent: "center", alignItems: "center", width: "100%", height: "100%"}}>
                                    <Typography className='FontInter' variant='h5' color="#fff" sx={{ fontSize: "22px", fontWeight: 700, fontFamily: 'sans-serif' }}>Network Manager</Typography>
                                    <Typography className='FontInter' variant='body' color="#fff" sx={{ fontSize: "14px", fontWeight: 300, mt: 1 }}>Seamless functionality meets effortless customization.</Typography>
                                </Box>
                                :
                                <Box sx={{ display: "flex",flexDirection:"column", justifyContent: "center", alignItems: "center", width: "100%", height: "100%"}}>
                                    <Typography className='FontInter' variant='h5' color="#fff" sx={{ fontSize: "22px", fontWeight: 700, fontFamily: 'sans-serif' }}>Network Manager</Typography>
                                    <Typography className='FontInter' variant='body' color="#fff" sx={{ fontSize: "14px", fontWeight: 300, mt: 1 }}>Effortless innovation for a seamless experience.</Typography>
                                </Box>
                            }
                            
                            <Stack direction="row" mt={5}>
                                {Array.from({ length: 3 }).map((_, index) => (
                                    <Box key={index} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                        <Box sx={{ width: 10, height: 10, borderRadius: "50%", backgroundColor: "#fff", marginRight: 2, opacity: SelectedIndex === index ? "100%" : "20%" }}></Box>
                                    </Box>
                                ))}
                            </Stack>
                        </Box>
                    </Stack>
                </Box>

            </Grid>
            <Grid item md={6} xs={12} paddingInline={{ xl: 15, lg: 15, md: 10, xs: 5 }} sx={{ backgroundColor: "#f7f7f7", height: '100vh' }}>
                <Stack height="100%" justifyContent="center" alignItems="center" >
                    <ChangePasswordForm />
                </Stack>
            </Grid>

        </Grid>



    );


}




export default ChangePassword;
